export enum AppRoutes {
    MAIN = 'main',
    AUTH = 'auth',
    ONBOARD_MOBILE = 'onboard-mobile',
    LOGIN = 'login',
    PROPERTIES = 'properties',

    PROPERTIES_ITEM = 'properties-item',
    PROPERTIES_CATALOG = 'properties-catalog',
    PROPERTIES_CATALOG_ITEMS = 'properties-catalog-items',
    PROPERTIES_CATALOG_ITEM = 'properties-catalog-item',

    PROPERTIES_GLOBAL_CATALOG = 'properties-global-catalog',
    PROPERTIES_GLOBAL_CATALOG_ITEMS = 'properties-global-catalog-items',
    PROPERTIES_GLOBAL_CATALOG_ITEM = 'properties-global-catalog-item',

    PROPERTIES_CATALOG_MANAGEMENT = 'properties-catalog-management',
    PROPERTIES_CATALOG_INVENTORY = 'properties-catalog-inventory',
    PROPERTIES_CATALOG_INVENTORY_ITEM = 'properties-catalog-inventory-item',
    PROPERTIES_CATALOG_INVENTORY_CATEGORIES = 'properties-catalog-inventory-categories',
    PROPERTIES_CATALOG_INVENTORY_CATEGORIES_ITEMS = 'properties-catalog-inventory-categories-items',
    PROPERTIES_CATALOG_INVENTORY_CATEGORIES_ITEM = 'properties-catalog-inventory-categories-item',

    INVENTORY_ADD = 'inventory-add',
    PROPERTIES_INFO = 'properties-info',

    ORDERS = 'orders',
    ORDERS_TABLE = 'orders-table',
    ORDERS_TABLE_STATUS = 'orders-table-status',
    ORDERS_ADD_ITEMS = 'orders-add-items',
    ORDERS_ADD_ITEMS_CATEGORIES = 'orders-add-items-categories',
    ORDERS_ADD_ITEMS_INVENTORY = 'orders-add-items-inventory',
    ORDERS_ADD_ITEMS_INVENTORY_DETAILED = 'orders-add-items-inventory-detailed',
    ORDERS_ADD_ITEMS_CATEGORIES_DETAILED = 'orders-add-items-categories-detailed',
    ORDERS_ADD_ITEMS_MARKETPLACE = 'orders-add-items-marketplace',
    ORDERS_ADD_ITEMS_MARKETPLACE_DETAILED = 'orders-add-items-marketplace-detailed',
    ORDERS_VIEW = 'orders-view',
    ORDERS_VIEW_ITEM_DETAILED = 'orders-view-item-detailed',

    REPORTS = 'reports',
    REPORTS_BY_CATEGORY = 'reports-by-category',
    REPORTS_SAVINGS_SUMMARY = 'reports-savings-summary',
    REPORTS_SAVINGS_PRODUCT_DRILLIN = 'reports-savings-product-drillin',
    REPORTS_SAVINGS_PROPERTY_DRILLIN = 'reports-savings-property-drillin',
    REPORTS_SAVINGS_CATEGORY_DRILLIN = 'reports-savings-category-drillin',
    SETTINGS = 'settings',
    SETTINGS_ORDERS = 'settings-orders',
    SETTINGS_ORDERS_SOURCING = 'settings-orders-sourcing',
    SETTINGS_ORDERS_DELIVERY = 'settings-orders-delivery',
    SETTINGS_ORDERS_SAVINGS = 'settings-orders-savings',

    VENDORS = 'vendors',
    VENDORS_SUPPLIER_PAGE = 'vendors-supplier-page',
    ADD_VENDORS_PAGE = 'add-vendors-page',
    PROFILE = 'profile',
    PRIVACY_POLICY = 'privacy-policy',
    TERMS_OF_SERVICE = 'terms-of-service',
    PRIVACY_POLICY_EMBEDED = 'privacy-policy-embeded',
    TERMS_OF_SERVICE_EMBEDED = 'terms-of-service-embeded',
    // error pages
    FORBIDDEN = 'forbidden',
    ACCESS_DENIED = 'access-denied',
    NOT_FOUND_PAGE = 'not-found-page',
    // last
    NOT_FOUND = 'not-found',
}

export const getRouteMain = () => '/';
export const getRouteAuth = () => '/auth';
export const getOnboardMobile = () => '/onboard-mobile';
export const getRouteLogin = () => '/login';
export const getRouteProperties = () => `/properties`;
//TODO: replace route when Home page will be ready
export const getRouteHome = () => '/properties';

export const getRoutePropertiesItem = (propertyId: string) =>
    `/properties/${propertyId}`;

export const getRoutePropertiesCatalog = (propertyId: string) =>
    `/properties/${propertyId}/catalog`;

export const getRouteGlobalCatalog = (propertyId: string) =>
    `/properties/${propertyId}/catalog/global`;

export const getRoutePropertiesCatalogSelected = (
    propertyId: string,
    categoryId: string,
) => `/properties/${propertyId}/catalog/${categoryId}`;

export const getRoutePropertiesGlobalCatalogSelected = (
    propertyId: string,
    categoryId: string,
) => `/properties/${propertyId}/catalog/global/${categoryId}`;

export const getRoutePropertiesCatalogItem = (
    propertyId: string,
    categoryId: string,
    itemId: string,
) => `/properties/${propertyId}/catalog/${categoryId}/item/${itemId}`;

export const getRouteGlobalCatalogItem = (
    propertyId: string,
    categoryId: string,
    itemId: string,
) => `/properties/${propertyId}/catalog/global/${categoryId}/item/${itemId}`;

export const getRoutePropertiesCatalogInventory = (propertyId: string) =>
    `/properties/${propertyId}/catalog/inventory`;

export const getRoutePropertiesCatalogInventoryItem = (
    propertyId: string,
    itemId: string,
) => `/properties/${propertyId}/catalog/inventory/${itemId}`;

export const getRouteOrderCatalogCategoriesItem = (itemId: string) =>
    `/orders/add-items/categories/${itemId}`;

export const getRouteOrderCatalogInventoryItem = (itemId: string) =>
    `/orders/add-items/inventory/${itemId}`;

export const getRoutePropertiesCatalogInventoryCategories = (
    propertyId: string,
) => `/properties/${propertyId}/catalog/inventory/categories`;

export const getRoutePropertiesCatalogInventoryCategoriesSelected = (
    propertyId: string,
    categoryId: string,
) => `/properties/${propertyId}/catalog/inventory/categories/${categoryId}`;

export const getRoutePropertiesCatalogInventoryCategoriesItem = (
    propertyId: string,
    categoryId: string,
    itemId: string,
) =>
    `/properties/${propertyId}/catalog/inventory/categories/${categoryId}/${itemId}`;

export const getRouteInventoryAdd = (propertyId: string) =>
    `/properties/${propertyId}/catalog/inventory/add`;

export const getRouteOrders = () => '/orders';
export const getRouteOrdersTable = (orderId: string) =>
    `/orders/properties/${orderId}`;

export const getRouteOrdersTableByStatus = (
    orderId: string,
    orderStatus: string,
) => `/orders/properties/${orderId}/status/${orderStatus}`;

export const getRouteOrdersAddItems = () => '/orders/add-items';
export const getRouteOrdersAddItemsCategories = () =>
    '/orders/add-items/categories';
export const getRouteOrdersAddItemsInventory = () =>
    '/orders/add-items/inventory';
export const getRouteOrdersAddItemsMarketplace = () =>
    '/orders/add-items/marketplace';
export const getRouteOrderMarketplaceCategory = (categoryId: string) =>
    `/orders/add-items/marketplace/${categoryId}`;
export const getRouteOrderMarketplaceItem = (
    categoryId: string,
    itemId: string,
) => `/orders/add-items/marketplace/${categoryId}/item/${itemId}`;

export const getRouteOrdersView = (id: string) => `/orders/${id}`;
export const getRouteOrdersViewItemDetailed = (
    orderId: string,
    itemId: string,
) => `/orders/${orderId}/item/${itemId}`;

export const getRouteMainReports = () => `/reports`;
export const getRouteMainVendors = (propertyId: string) =>
    `/vendors/property/${propertyId}`;
export const getRouteAddVendors = (propertyId: string) =>
    `/vendors/property/${propertyId}/add-vendors`;
export const getRouteVendorsSupplierPage = (
    supplierId: string,
    propertyId: string,
) => `/vendors/property/${propertyId}/suppliers/${supplierId}`;
export const getRouteReportsByCategory = () => `/reports/category`;
export const getRouteReportsSavingsSummary = () => `/reports/savings-summary`;

const encodeRouteSegment = (value: string) =>
    value.startsWith(':') ? value : encodeURIComponent(value);

export const getRouteReportsSavingsSummaryProduct = (sku: string) =>
    `/reports/savings-summary/product/${encodeRouteSegment(sku)}`;
export const getRouteReportsSavingsSummaryProperty = (propertyId: string) =>
    `/reports/savings-summary/property/${encodeRouteSegment(propertyId)}`;
export const getRouteReportsSavingsSummaryCategory = (categoryId: string) =>
    `/reports/savings-summary/category/${encodeRouteSegment(categoryId)}`;

export const getRouteSettings = () => `/settings`;

export const getRouteSettingsOrdersSourcing = (
    propertyId: string,
    orderType: string,
) => `/settings/${propertyId}/orders/${orderType}`;
export const getRouteSettingsOrdersDelivery = (
    propertyId: string,
    orderType: string,
) => `/settings/${propertyId}/orders/${orderType}/delivery`;
export const getRouteSettingsOrdersSavings = (
    propertyId: string,
    orderType: string,
) => `/settings/${propertyId}/orders/${orderType}/savings`;

export const getRouteProfile = () => `/profile/details`;
export const getRoutePrivacyPolicy = () => `/privacy-policy`;
export const getRouteTermsOfService = () => `/terms-of-service`;
export const getRoutePrivacyPolicyEmbeded = () => `/profile/privacy-policy`;
export const getRouteTermsOfServiceEmbeded = () => `/profile/terms-of-service`;

//error pages
export const getRouteAccessDenied = () => '/access-denied';
export const getRouteForbidden = () => '/forbidden';
export const getRouteNotFound = () => '/not-found';
